import React, { useEffect, useState, useRef } from 'react';
import AsyncSelect from 'react-select/async';
import Select, { defaultTheme } from 'react-select';
import { isSet } from '../../../utils/commonUtils';

const { colors } = defaultTheme;

const selectStyles = {
  singleValue: (provided, state) => ({
    ...provided,
    display: 'none',
  }),
  // multiValue: (base) => ({
  //   ...base,
  //   overflow: 'hidden',
  //   textOverflow: 'ellipsis',
  //   whiteSpace: 'nowrap',
  //   maxWidth: '150px', // Adjust this value as needed
  // }),
  // multiValueLabel: (base) => ({
  //   ...base,
  //   overflow: 'hidden',
  //   textOverflow: 'ellipsis',
  //   whiteSpace: 'nowrap',
  //   maxWidth: '150px', // Adjust this value as needed
  // }),
  // placeholder: (provided, state) => ({
  //   ...provided,
  //   display: state.hasValue ? 'none' : 'block',
  //   color: 'gray',
  // }),
  control: (provided) => ({
    ...provided,
    margin: 8,
  }),
  menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
};

const SelectSearchFields = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [asyncOptions, setAsyncOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const {
    className,
    name,
    isMulti,
    isAutoPopulate,
    options,
    value,
    style,
    focusStyle,
    readOnly,
    isAsync,
    isCacheNeeded,
    required,
    placeholder,
    loadCallBack,
    changeHandler,
    displayValue='',
  } = props;

  useEffect(() => {
    if (loadCallBack && isAsync) {
      setAsyncOptions([]);
      setLoading(true);
      loadCallBack('', (loadedOptions) => {
        setAsyncOptions(loadedOptions);
        setLoading(false);
      });
    }
  }, [props.reload]);
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
      setInputValue(''); // Clear the input value when opening the dropdown
    }
  }, [isOpen]);

  const handleChange = (selectedOption,{action}) => {
   
    // console.log('selectedOption',selectedOption);
    // if(isMulti===false && action==='clear'){
    //   return false;
    // }
    if (isMulti) {
      let multiSelectValue = [];
      let multiSelectlabel= []
      selectedOption.forEach((item) => {
        multiSelectValue.push(item.value);
        multiSelectlabel.push(item.label);
      });
      changeHandler(multiSelectValue.join(','),{},multiSelectlabel.join(','));
    } else if (isAutoPopulate) {
      changeHandler(isSet(selectedOption,{value:''}).value, { autoPopulates: selectedOption.autoPopulateFields },'');
    } else {
      changeHandler(isSet(selectedOption, { value: '' }).value,{},selectedOption.label||"");
    }
    if(action==='select-option' && isMulti===false){
      setIsOpen(false);
    }
  };

  let defaultValueOptions = [];
  let displayValueOptions = displayValue || "";
  
  const optionArr = Array.isArray(asyncOptions) && asyncOptions.length > 0
  ? asyncOptions
  : Array.isArray(options)
  ? options
  : [];
  optionArr.forEach((item) => {
    if (isMulti) {
      if (value?.split(',').includes(item.value)) {
        defaultValueOptions.push(item);
        // displayValueOptions.push(item.label);
      }
    } else if (value === item.value) {
      // displayValueOptions.push(item.label);
      defaultValueOptions.push(item);
    }
  });

  const requiredStyles = required ? {
    borderLeft: '2px solid red',
    borderRadius: '0.35rem',
  } : {};

  return (
    <div id={isSet(props.id,name)} style={{ position: 'relative', ...requiredStyles }}>
      <div
        // className={className}
        className={`${className} text-truncate`}
        onClick={(readOnly === true) ? () => {} : () => setIsOpen((prev) => !prev)}
        style={{
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          padding: '8px',
          border: '1px solid var(--snap-common-border)',
          borderRadius: '0.35rem',
          width: '100%', // Ensure it takes the full width of the container
        }}
        title={displayValueOptions}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {isMulti===true?
        isSet(displayValueOptions, []).length > 0 ? (displayValueOptions.length>2)?`${displayValueOptions.length} items selected...`:`${displayValueOptions.join(', ')}` : '-Select-'
        :displayValueOptions.length>0?displayValueOptions: '-Select-'
        }
      </span>
        <ChevronDown />
      </div>
      {isOpen && (
        <Menu>
          {isAsync ? (
            <AsyncSelect
              cacheOptions={isCacheNeeded}
              loadOptions={(inputValue, callback) => {
                loadCallBack(inputValue, (loadedOptions) => {
                  setAsyncOptions(loadedOptions);
                  callback(loadedOptions);
                });
              }}
              closeMenuOnScroll={true}
              defaultOptions
              isLoading={isLoading}
              isDisabled={readOnly}
              name={name}
              id={isSet(props.id,name)}
              value={defaultValueOptions}
              onChange={handleChange}
              components={{ DropdownIndicator, IndicatorSeparator: null }}
              placeholder={placeholder}
              styles={selectStyles}
              menuIsOpen
              isMulti={isMulti}
              inputValue={inputValue}
              onInputChange={(newValue) => setInputValue(newValue)}
              ref={inputRef}
              // isClearable
            />
          ) : (
            <Select
              closeMenuOnScroll={true}
              cacheOptions
              isSearchable
              options={options}
              name={name}
              id={isSet(props.id,name)}
              value={defaultValueOptions}
              onChange={handleChange}
              placeholder={placeholder}
              styles={selectStyles}
              isMulti={isMulti}
              components={{ DropdownIndicator, IndicatorSeparator: null }}
              menuIsOpen
              inputValue={inputValue}
              onInputChange={(newValue) => setInputValue(newValue)}
              ref={inputRef}
              // isClearable
            />
          )}
        </Menu>
      )}
      {isOpen && <Blanket onClick={() => setIsOpen(false)} />}
    </div>
  );
};

// Styled components
const Menu = (props) => {
  const shadow = 'hsla(218, 50%, 10%, 0.1)';
  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: 'absolute',
        zIndex: 2,
        width: '100%',
      }}
      {...props}
    />
  );
};

const Blanket = (props) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: 'fixed',
      zIndex: 1,
    }}
    {...props}
  />
);

const Svg = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...props}
  />
);

const DropdownIndicator = () => (
  <div
    style={{
      color: colors.neutral20,
      height: 24,
      width: 32,
    }}
  >
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);

const ChevronDown = () => (
  <Svg style={{ marginRight: -6 }}>
    <path
      d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Svg>
);

SelectSearchFields.defaultProps = {
  isMandatory: false,
  className: 'form-control form-control-solid text-truncate',
  placeholder: 'Search',
  value: '',
  style: {},
  focusStyle: {},
  options: [],
  isCacheNeeded: true,
  loadCallBack: () => {},
  onKeyPressHandler: () => {},
  readOnly: false,
  required: false,
  isMulti: false,
  isAutoPopulate: false,
  isAsync: false,
  validation: {
    isValid: true,
    message: '',
  },
};

export default SelectSearchFields;








